import EVENTS from '@shared/events';
import { BaseController } from '@shared/basecontroller.controller';
import { BitcoinDepositForm } from './bitcoinform.model';

import QRious from 'qrious';

class BitcoinFormController extends BaseController {
  constructor( 
      AppService,
      PaymentOptionApiService,
      TransactionApiService, 
      CustomerApiService, 
      $timeout,
      $document,
    ) {
    'ngInject';

    super(AppService);

    this.PaymentOptionApiService = PaymentOptionApiService;
    this.TransactionApiService = TransactionApiService;
    this.CustomerApiService = CustomerApiService;
    this.$timeout = $timeout;
    this.$document = $document;

    this.bitcoinRate = null;
    this.bitcoinTransaction == null;
  }

  $onInit() {
    this.form = new BitcoinDepositForm(this.details.customerProducts, this.details.paymentOptions);
    this.paymentOptionsViewDetails = this.details.paymentOptionsViewDetails;

    this.form.paymentOption = this.selectedPaymentOption.id;
    this.form.paymentOptionType = this.selectedPaymentOption.type;
    this.form.feeMultiplier = this.paymentOptionsViewDetails.feeFor('deposit');
    this.form.feeFree = this.paymentOptionsViewDetails.isFeeFreeFor('deposit');
    this.form.email = this.selectedPaymentOption.email;

    this.addListener(EVENTS.BTC_EXCHANGE_RATE, event => {
      if (event.bitcoinRate.type === 'deposit') {
        this.form.bitcoinRate = event.bitcoinRate;
        this.blinkExchangeRate();
        this.bitcoinRate = event.bitcoinRate;
        this.onBtcInputChanged();
      }
    });

    this.addListener(EVENTS.TRANSACTION_DECLINED, declinedEvent => {
      if (declinedEvent.transactionId === this.bitcoinTransaction.id) {
        this.bitcoinTransaction.isDeclined = true;
        this.showNecessaryModals();
      }   
    });

    this.addListener(EVENTS.BITCOIN_RATE_TRANSACTION_EXPIRED, event => {
      if (event.transactionId === this.bitcoinTransaction.id) {
        this.bitcoinTransaction.isRateExpired = true;
        this.showNecessaryModals();
      }
    });

    // Display the form when all the promises has been completed.
    Promise.all([this.getBitcoinRate(), this.checkForActiveBitcoinTransaction()]).then((values) => {
      this.form.props.isReady = true;
    });

    this.$timeout(() => {
      $(".gateway-sidebar-wrap .fa-receipt").click(function(e){
        e.preventDefault();
        $(".gateway-sidebar-wrap").toggleClass('active');
      });
    }, 500);

    this.$timeout(() => {
      $("#qr-modal .close").click(function(){
        $('#qr-modal').hide();
      });
    }, 500);
  }

  $onDestroy() {
    super.$onDestroy();
    
    if (this.timerInterval !== null) {
      clearInterval(this.timerInterval);
    }
  }

  // This would handle the initial display when loading the Bitcoin Form.
  getBitcoinRate() {
    return this.PaymentOptionApiService.getBitcoinAdjustment().then(bitcoinRate => {
      this.bitcoinRate = bitcoinRate;
      // TODO: Do not set bitcoinRate on form.
      this.form.bitcoinRate = bitcoinRate;
    });
  }

  checkForActiveBitcoinTransaction() {
    return this.TransactionApiService.checkForActiveBitcoinTransaction().then(bitcoinTransaction => {
      this.bitcoinTransaction = bitcoinTransaction;
      if (this.bitcoinTransaction) {
        this.createQRCode();
        this.form = BitcoinDepositForm.fill(this.details.customerProducts, this.details.paymentOptions, this.bitcoinTransaction.bitcoinSubtransactions);
        this.addConfirmationSubscription(this.bitcoinTransaction.id);

        if (this.bitcoinTransaction.isTimeRemainingExpired) {
          this.declineBitcoinTransaction().then(() => {
            this.bitcoinTransaction.isDeclined = true;
            this.showNecessaryModals();
          });
        } else {
          this.startTimer();
          this.showNecessaryModals();
        }
      }
    });
  }

  addConfirmationSubscription(transactionId) {
  }

  showNecessaryModals() {
    if (this.isBitcoinTransactionConfirmed) {
      this.$timeout(() => {
        $('#btc-confirmation-modal').show();
      }, 1000);
    }
    
    if (this.isBitcoinTransactionDeclined) {
      this.$timeout(() => {
        $('#btc-rate-expired-modal').hide();
        $('#btc-declined-modal').show();
      }, 500);
    }

    if (this.isBitcoinTransactionPending) {
      this.$timeout(() => {
        $('#btc-rate-expired-modal').hide();
        $('#btc-pending-confirmation-modal').show();
      }, 500);
    }

    if (this.isBitcoinRateExpired && 
      !this.isBitcoinTransactionDeclined && 
      !this.isBitcoinTransactionPending &&
      !this.isBitcoinTransactionConfirmed) {
      this.$timeout(() => {
        $('#btc-rate-expired-modal').show();
      }, 500);
    }
  }

  showQrModal() {
    this.$timeout(() => {
      $('#qr-modal').show();
      this.createQRCodeModal();
    }, 1000);
  }

  closeModal() {
    this.$timeout(() => {
      $('#qr-modal').hide();
    }, 500);
  }

  startTimer() {
    if (this.bitcoinTransaction === null || this.bitcoinTransaction.isRateExpired) {
      return;
    }
  
    const timerDom = this.$document[0].getElementsByClassName('btc-timer');
    
    if (this.bitcoinTransaction.isLockDownRateTimeExpired) {
      timerDom[0].innerHTML = '00:00:00';

      if (!this.bitcoinTransaction.isRateExpired) {
        this.lockRateBitcoinTransaction();
      }
    
      return;
    }
    
    const timeRemaining = this.bitcoinTransaction.lockDownRateTimeRemaining;
    timerDom.innerHTML = timeRemaining.format('HH:mm:ss');

    const isExpired = (moment) => {
      return moment.format('HH:mm:ss') === '00:00:00';
    }
    
    // Make sure that there is only 1 running instance of interval
    if (this.timerInterval) {
      clearInterval(this.timerInterval);
    }

    this.timerInterval = setInterval(() => {
      timeRemaining.subtract(1, 'seconds');
      if (isExpired(timeRemaining)) {
        clearInterval(this.timerInterval);
        this.lockRateBitcoinTransaction();
      }

      timerDom[0].innerHTML = timeRemaining.format('HH:mm:ss');
      if (timerDom[1]) {
        timerDom[1].innerHTML = timeRemaining.format('HH:mm:ss'); 
      }
    }, 1000);
  }

  blinkExchangeRate() {
    const exchangeRate = document.getElementsByClassName('exchange-rate')[0];
    exchangeRate.classList.add('blinking');

    let seconds = 0;

    this.blinkInterval = setInterval(() => {
      seconds += 1000;

      if (seconds === 2000) {
        exchangeRate.classList.remove('blinking');
        clearInterval(this.blinkInterval);
      }
    }, 2000);
  }

  declineBitcoinTransaction() {
    return this.TransactionApiService.declineBitcoinTransaction();
  }

  lockRateBitcoinTransaction() {
    this.TransactionApiService.lockRateBitcoinTransaction();
  }

  submit() {
    this.form.props.isSubmitting = true;
    this.TransactionApiService.deposit(this.form.toPayload(this.bitcoinRate))
    .then(() => this.handleSuccessfulSubmission())
    .catch((errors) => {
      console.error(errors);
      this.form.props.isSubmitting = false;
      this.form.error.setFormErrors(errors);
    });
  }

  handleSuccessfulSubmission() {
    this.checkForActiveBitcoinTransaction().then(() => {
      this.form.props.isSubmitting = false;
      this.updatePaymentOption();
    });
  }

  removeSubTransaction(subTransaction, index) {
    this.form.removeSubTransaction(subTransaction, index);
    this.onBtcInputChanged(); 
  }

  formatAmount(subTransaction) {
    return subTransaction.amount = parseFloat(subTransaction.amount);
  }

  formatBTC(subTransaction) {
    return subTransaction.btc = parseFloat(subTransaction.btc);
  }

  createQRCode() {
    this.$timeout(() => {
      const qr = new QRious({
        element: document.getElementById('qr'),
        size: 200,
        value: this.bitcoinTransaction.receivingAddress,
      });

    }, 1000);
  }

  createQRCodeModal() {
    const qrModal = new QRious({
      element: document.getElementById('qr-canvass-modal'),
      size: 100,
      value: this.bitcoinTransaction.receivingAddress,
    });
  }

  onBtcInputChanged() {
    let adjustedRate = this.form.getBtcAdjustedRate(this.bitcoinRate);

    let btcAdjustedDisplay = document.getElementById('btc-adjusted-value');
    btcAdjustedDisplay.innerHTML = adjustedRate;

    // Do not recompute if there is current transaction
    if (this.bitcoinTransaction === null) {
      this.form.computeAmountConversion(adjustedRate);
    }
  }

  onAmountInputChanged() {
    let adjustedRate = this.form.getBtcAdjustedRateFromTotalAmount(this.bitcoinRate);

    let btcAdjustedDisplay = document.getElementById('btc-adjusted-value');
    btcAdjustedDisplay.innerHTML = adjustedRate;

    // Do not recompute if there is current transaction
    if (this.bitcoinTransaction === null) {
      this.form.computeBitcoinConversion(adjustedRate); 
    }
  }

  get isBitcoinTransactionRequested() {
    if (this.bitcoinTransaction && this.bitcoinTransaction.isRequested) {
      return true;
    }

    return false;
  }

  get isBitcoinTransactionPending() {
    if (this.bitcoinTransaction && this.bitcoinTransaction.isPending) {
      return true;
    }

    return false;
  }

  get isBitcoinTransactionConfirmed() {
    if (this.bitcoinTransaction && this.bitcoinTransaction.isConfirmed) { 
      return true;
    }

    return false;
  }

  get isBitcoinTransactionDeclined() {
    if (this.bitcoinTransaction && this.bitcoinTransaction.isDeclined) { 
      return true;
    }

    return false;
  }

  get isBitcoinRateExpired() {
    if (this.bitcoinTransaction && this.bitcoinTransaction.isRateExpired) { 
      return true;
    }

    return false;
  }

  get isBitcoinTransactionOnProcess() {
    return this.isBitcoinTransactionConfirmed || this.isBitcoinTransactionDeclined || this.isBitcoinTransactionPending || this.isBitcoinTransactionRequested;
  }

  acknowledgeTransaction() {
    if (this.bitcoinTransaction !== null) {
      this.TransactionApiService.acknowledgeBitcoinTransaction().then(() => {
        this.bitcoinTransaction = null;
        this.form.reset();
        // TODO: Investigate why paymentOptionType becomes null on form reset.
        this.form.paymentOptionType = this.selectedPaymentOption.type;

        clearInterval(this.timerInterval);
        
        $('#btc-confirmation-modal').hide(); 
        $('#btc-declined-modal').hide();
        
        this.checkForActiveBitcoinTransaction().then(() => {
          this.updatePaymentOption();
        });
      });
    }
  }

  // Update the current selected payment option.
  // This is to ensure that when a payment option is newly created it
  // keeps synced with the ui and the form model.
  updatePaymentOption() {
    this.CustomerApiService.getPaymentOptions().then(updatedPaymentOptions => {
      for (let updatedPaymentOption of updatedPaymentOptions) {
        if (updatedPaymentOption.type === this.selectedPaymentOption.type) {
          this.selectedPaymentOption.id = updatedPaymentOption.id;
          this.form.paymentOption = updatedPaymentOption.id;
        }
      }
    });
  }

  get displayDeleteButton() {
    return this.form.subTransactions.length > 1;
  }
}

export default BitcoinFormController;



// WEBPACK FOOTER //
// ./client/app/pages/customer/deposit/component/form/bitcoin/bitcoinform.controller.js